import { render, staticRenderFns } from "./Transparencia.vue?vue&type=template&id=4b83598e&"
import script from "./Transparencia.vue?vue&type=script&lang=js&"
export * from "./Transparencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports